// extracted by mini-css-extract-plugin
export default {"square":"WorkPlanPopover_square__JExD8","transform":"WorkPlanPopover_transform__Tlr3y","dropdownItems":"WorkPlanPopover_dropdownItems__cDlsJ"};